// import { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   Box,
//   Avatar,
//   Divider,
//   ButtonBase,
//   Typography,
//   Menu,
//   MenuItem,
//   styled,
// } from "@mui/material";

// const StyledButtonBase = styled(ButtonBase)(({ theme }) => ({
//   marginLeft: 8,
//   borderRadius: 30,
//   padding: 4,
//   border: `1px solid ${theme.palette.grey[200]}`,
//   "&:hover": { backgroundColor: theme.palette.action.hover },
// }));

// export default function ProfilePopover() {
//   const [anchorEl, setAnchorEl] = useState(null);
//   const open = Boolean(anchorEl);
//   const navigate = useNavigate();

//   // Dohvaćanje podataka spremljenih pri login-u
//   const userName = localStorage.getItem("name") || "Korisnik";
//   const userEmail = localStorage.getItem("email") || "email@g3spirits.com";

//   const handleOpen = (event) => setAnchorEl(event.currentTarget);
//   const handleClose = () => setAnchorEl(null);

//   const handleLogout = () => {
//     localStorage.clear(); // Briše token, user_id, tvrtka_id...
//     navigate("/"); // Vraća na login
//   };

//   return (
//     <>
//       <StyledButtonBase onClick={handleOpen}>
//         <Avatar
//           sx={{ width: 32, height: 32, fontSize: "1rem", bgcolor: "#284c7a" }}
//         >
//           {userName.charAt(0).toUpperCase()}
//         </Avatar>
//       </StyledButtonBase>

//       <Menu
//         anchorEl={anchorEl}
//         open={open}
//         onClose={handleClose}
//         // ZAMJENA: Umjesto PaperProps koristimo slotProps.paper
//         slotProps={{
//           paper: {
//             elevation: 0,
//             sx: {
//               width: 220,
//               mt: 1.5,
//               borderRadius: "12px", // Moderniji zaobljeni rubovi
//               overflow: "visible",
//               filter: "drop-shadow(0px 4px 12px rgba(0,0,0,0.1))",
//               border: "1px solid rgba(0,0,0,0.08)",
//               "& .MuiAvatar-root": {
//                 width: 32,
//                 height: 32,
//                 ml: -0.5,
//                 mr: 1,
//               },
//             },
//           },
//         }}
//         transformOrigin={{ horizontal: "right", vertical: "top" }}
//         anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
//       >
//         <Box px={2.5} py={2}>
//           <Typography
//             variant="subtitle2"
//             fontWeight="700"
//             color="text.primary"
//             noWrap
//           >
//             {userName}
//           </Typography>
//           <Typography
//             variant="caption"
//             color="text.secondary"
//             noWrap
//             sx={{ display: "block" }}
//           >
//             {userEmail}
//           </Typography>
//         </Box>

//         <Divider sx={{ borderStyle: "dashed" }} />

//         <MenuItem
//           onClick={handleLogout}
//           sx={{
//             py: 1.5,
//             px: 2.5,
//             color: "error.main",
//             fontWeight: 600,
//             fontSize: "0.875rem",
//             "&:hover": { backgroundColor: "rgba(211, 47, 47, 0.04)" },
//           }}
//         >
//           Odjavite se
//         </MenuItem>
//       </Menu>
//     </>
//   );
// }

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Avatar,
  Divider,
  ButtonBase,
  Typography,
  Menu,
  MenuItem,
  styled,
  useMediaQuery,
  useTheme,
} from "@mui/material";

const StyledButtonBase = styled(ButtonBase)(({ theme }) => ({
  marginLeft: 8,
  borderRadius: 30,
  padding: "4px 8px", // Više mjesta za prst na mobitelu
  border: `1px solid rgba(255,255,255,0.3)`, // Suptilnije na plavoj pozadini
  color: "white",
  "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" },
}));

export default function ProfilePopover() {
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const userName = localStorage.getItem("name") || "Korisnik";
  const userEmail = localStorage.getItem("email") || "email@g3spirits.com";

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <>
      <StyledButtonBase onClick={handleOpen}>
        <Avatar
          sx={{
            width: 28,
            height: 28,
            fontSize: "0.85rem",
            bgcolor: "white",
            color: "#284c7a",
          }}
        >
          {userName.charAt(0).toUpperCase()}
        </Avatar>
        {!isMobile && (
          <Typography variant="body2" sx={{ ml: 1, fontWeight: 600 }}>
            {userName.split(" ")[0]}
          </Typography>
        )}
      </StyledButtonBase>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              width: isMobile ? 180 : 220, // Uže na mobitelu
              mt: 1.5,
              borderRadius: "12px",
              filter: "drop-shadow(0px 4px 12px rgba(0,0,0,0.15))",
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <Box px={2} py={1.5}>
          <Typography variant="subtitle2" fontWeight="700" noWrap>
            {userName}
          </Typography>
          <Typography
            variant="caption"
            color="text.secondary"
            noWrap
            sx={{ display: "block" }}
          >
            {userEmail}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: "dashed" }} />

        <MenuItem
          onClick={handleLogout}
          sx={{
            py: 1.2,
            px: 2,
            color: "error.main",
            fontWeight: 600,
            fontSize: "0.875rem",
          }}
        >
          Odjavi se
        </MenuItem>
      </Menu>
    </>
  );
}
